import React from "react";
import {Col, Row} from "antd";
import AccountInput from "./accountInput";

export default props => {
    function renderLabelOrInput() {
        if (props.editing) {
            return (
                <AccountInput
                    style={{ maxWidth: 300 }}
                    name={props.name}
                    labelText={props.labelText}
                    label={props.label}
                    type={props.type}
                    mask={props.mask}/>
            )
        } else {
            return <span className={"account-card-data"}>{props.value}</span>
        }
    }

    function renderSecondInput() {
        if (props.secondName && props.editing) {
            return (
                <>
                    <br/>

                    <Row gutter={20} style={{
                        paddingBottom: 16,
                        display: "flex",
                        alignItems: "center",
                        borderBottom: props.noBorder ? "unset" : "1px solid #eceef1",
                    }}>
                        <Col span={4}/>
                        <Col span={10}>
                            <AccountInput
                                style={{ maxWidth: 300 }}
                                name={props.secondName}
                                labelText={props.secondLabelText}
                                label={props.secondLabel}/>
                        </Col>
                        <Col span={10}/>
                    </Row>
                </>
            )
        }
    }

    function renderBorderBottom() {
        if (props.noBorder || props.secondName) {
            return "unset"
        } else {
            return "1px solid #eceef1"
        }
    }

    function renderPaddingBottom(){
        if (props.secondName) {
            return "unset"
        }else{
            return "16px"
        }
    }

    return (
        <>
            <Row gutter={20} style={{
                borderBottom: props.editing ? renderBorderBottom() : "1px solid #eceef1",
                paddingBottom: props.editing ? renderPaddingBottom() : 16,
                marginTop: 16,
                display: "flex",
                alignItems: "center"
            }}>
                <Col span={4}>
                    <span className={"account-card-label"}>{props.label}</span>
                </Col>
                <Col span={10}>
                    {renderLabelOrInput()}
                </Col>
                <Col span={10}>
                    
                </Col>
            </Row>

            {renderSecondInput()}
        </>
    )
}
